var map = {
	"./img-app1.png": "hXf4",
	"./img-app2.png": "+OpR",
	"./img-app3.png": "tzd4",
	"./img-app4.png": "4Uex",
	"./img-app5.png": "sua/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fH/b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/img\-app.*\.png$
// module id = fH/b
// module chunks = 1